import axiosInstance from '../utils/AxiosConfig';

const unwrap = (response) => response.data?.data ?? response.data;

export const EXPENSE_CATEGORIES = [
  'SUELDOS',
  'ALQUILER',
  'SERVICIOS',
  'IMPUESTOS',
  'MARKETING',
  'MANTENIMIENTO',
  'LOGISTICA',
  'OTROS'
];

export const EXPENSE_FREQUENCIES = [
  'WEEKLY',
  'MONTHLY',
  'BIMONTHLY',
  'QUARTERLY',
  'YEARLY'
];

export const listExpenses = async (params = {}) => {
  const response = await axiosInstance.get('/expenses', { params });
  return unwrap(response);
};

export const getExpenseMetadata = async () => {
  const response = await axiosInstance.get('/expenses/metadata');
  return unwrap(response);
};

export const createExpense = async (payload) => {
  const response = await axiosInstance.post('/expenses', payload);
  return unwrap(response);
};

export const updateExpense = async (id, payload) => {
  const response = await axiosInstance.put(`/expenses/${id}`, payload);
  return unwrap(response);
};

export const changeExpenseAmount = async (id, payload) => {
  const response = await axiosInstance.post(`/expenses/${id}/amount-versions`, payload);
  return unwrap(response);
};

export const listExpenseOccurrences = async (params = {}) => {
  const response = await axiosInstance.get('/expenses/occurrences', { params });
  return unwrap(response);
};

export const addExpensePayment = async (occurrenceId, payload) => {
  const response = await axiosInstance.post(`/expenses/occurrences/${occurrenceId}/payments`, payload);
  return unwrap(response);
};

export const cancelExpenseOccurrence = async (occurrenceId, payload = {}) => {
  const response = await axiosInstance.post(`/expenses/occurrences/${occurrenceId}/cancel`, payload);
  return unwrap(response);
};

export const getExpenseHistory = async (id) => {
  const response = await axiosInstance.get(`/expenses/${id}/history`);
  return unwrap(response);
};

export const getExpenseSummary = async (params = {}) => {
  const response = await axiosInstance.get('/expenses/summary', { params });
  return unwrap(response);
};

export const getExpenseCommissionSummary = async (params = {}) => {
  const response = await axiosInstance.get('/expenses/commissions', { params });
  return unwrap(response);
};
